import { Component, ViewChild } from '@angular/core';
import { SitenavComponent } from '../../nav/sitenav/sitenav.component';
import { SiteToolbarComponent } from '../../nav/site-toolbar/site-toolbar.component';
import { SiteToolbarButtonsComponent } from '../../nav/site-toolbar-buttons/site-toolbar-buttons.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-main',
  imports: [SitenavComponent, SiteToolbarComponent, SiteToolbarButtonsComponent, RouterModule],
  templateUrl: './main.html',
  styleUrl: './main.scss',
})
export class Main {

  @ViewChild(SitenavComponent) sitenav!: SitenavComponent;

  onToggleMobileMenu() {
    if (this.sitenav) {
      
      this.sitenav.toggleMobile();
    } else {
      console.warn('Sitenav component not found!');
    }
  }

}
